<template>
  <b-container>
    <div class="box-head">
      <Title
        main="J U D G E S"
        des="ADMAN JUDGES 2019"
      />

      <select
        v-model="selectCate"
      >
        <option
          v-for="(cate, i) in dataSelect"
          :key="i"
          :value="cate"
        >
          {{ cate }}
        </option>
      </select>

      <div class="box-title">
        <div></div>
        <h1>{{ selectCate }}</h1>
      </div>
    </div>
    <div class="box-content">
      <Loading v-if="isLoading" />
      <b-row v-if="!isLoading">
        <b-col
          v-for="list in judgeList"
          :key="list.id"
          cols="12"
          md="3"
          class="col"
        >
          <Card
            :data="list"
          />
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'

const Title = () => import('@/components/About/Parts/Title')
const Loading = () => import('./Loading')
const Card = () => import('./Card')

export default {
  components: {
    Title,
    Loading,
    Card
  },

  data () {
    return {
      selectCate: 'AD THAT WORKS (EFFECTIVE COMMUNICATION)',
      dataSelect: []
    }
  },

  computed: {
    ...mapState({
      isLoading: state => state.awards.isLoading,
      judgeCates: state => state.awards.judgeCates,
      judgeList: state => state.awards.judgeList
    })
  },

  methods: {
    filterCate (data) {
      const filter = this.judgeCates.filter(cate =>
        cate.name === data
      )

      return filter
    },

    async getDetail (cate) {
      const filter = await this.filterCate(cate)

      await this.$store.dispatch('awards/getJudgeList', filter[0].id)
    },

    selectOrder (data) {
      if (data) {
        const arr = []

        data.forEach(item => {
          arr.push(item.name)
        })

        const newArr = arr.sort((a, b) => (a > b) ? 1 : -1)

        this.dataSelect = newArr
      }
    }
  },

  created () {
    this.getDetail(this.selectCate)
    this.selectOrder(this.judgeCates)
  },

  watch: {
    selectCate (cate) {
      this.getDetail(cate)
    },

    judgeCates (data) {
      this.selectOrder(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.container {
  .box-head {
    padding-top: 22px;
    border-bottom: 6px solid #CCC;

    select {
      padding: 6px 50px 6px 12px;
      width: 100%;
      border-radius: 0;
      border: 1px solid #888;
      background-color: white;
      background-image: url('../../../assets/icons/icon-caret-down.png');
      background-repeat: no-repeat;
      background-position: right .7em top 50%, 0 0;
      background-size: 30px auto, 100%;
      font-size: 1.25rem;

      @media only screen and (min-width: $break-m) {
        width: 42%;
      }
    }

    .box-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 22px 0;

      div {
        width: 15px;
        height: 15px;
        background-color: $active;
      }

      h1 {
        margin-left: 12px;
        font-size: 1.75rem;
      }
    }
  }

  .box-content {
    padding: 22px 0;
  }
}
</style>
